/* eslint-disable react/require-default-props */
import React from 'react';
import PropTypes from 'prop-types';
import {
  Card, CardActions, CardContent, CardMedia, Typography, ButtonGroup,
} from '@material-ui/core';
import { v4 as uuidv4 } from 'uuid';
import CardButton from './CardButton';
import { isIntentKeyword } from '../../utils';

function Cards(props) {
  const {
    image, title, description, buttons,
  } = props;
  return (
    <div className="rcw-message">
      <div className="rcw-response">
        <div className="rcw-message-text">
          <Card>
            {image.url && (
              <CardMedia
                component="video"
                height="140"
                style={{
                  backgroundImage: `url(${image.url})`,
                }}
              />
            )}
            { ((title && title !== '⠀‌‌') || description) && (
              <CardContent>
                {title && title !== '⠀‌‌' && (
                  <Typography gutterBottom variant="h6" component="h2">
                    {title}
                  </Typography>
                )}
                {description && (
                  <Typography variant="body2" color="textSecondary" component="p">
                    {description}
                  </Typography>
                )}
              </CardContent>
            )}
            <CardActions>
              {
                buttons.length === 0 && title
                  ? (
                    <CardButton
                      title="Select"
                    />
                  ) : ''
              }
              <ButtonGroup
                orientation="vertical"
                fullWidth
              >
                {buttons.map((x) => (
                  !isIntentKeyword(x.title)
                  && (
                  <CardButton
                    key={uuidv4()}
                    title={x.title}
                    url={x.url}
                  />
                  )
                ))}
              </ButtonGroup>
            </CardActions>
          </Card>
        </div>
      </div>
    </div>
  );
}

Cards.propTypes = {
  image: PropTypes.shape({
    url: PropTypes.string,
    placeholder: PropTypes.string,
  }),
  title: PropTypes.string,
  description: PropTypes.string,
  buttons: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      url: PropTypes.string,
    }),
  ),
};

Cards.defaultProps = {
  image: {},
  title: '',
  description: '',
  buttons: [],
};

export default Cards;
